import { RolePermission, PermissionList } from '../hooks';
import { Images } from 'utils';
import libraryTab from '../../assets/images/icons/leftBar/libraryTab.svg';

export const superAdminRouters = (cSession) => [
    {
        name: 'Dashboard',
        icon: Images.dashboardTab,
        activeIcon: Images.dashboardTabActive,
        path: '/dashboard',
    },

    RolePermission([PermissionList.FS_LIST_READ?.code]) && {
        name: 'Payer',
        icon: Images.fsTab,
        activeIcon: Images.fsTabActive,
        path: '/fundingSource',
    },

    RolePermission([PermissionList.STAFF_LIST_READ.code, PermissionList.STAFF_CONNECTED_LIST_READ.code]) && {
        name: 'Staff',
        icon: Images.staffTab,
        activeIcon: Images.staffTabActive,
        path: '/staff',
    },

    RolePermission([PermissionList.CLIENT_LIST_READ?.code, PermissionList.CONNECTED_CLIENT_READ?.code]) && {
        name: 'Client',
        icon: Images.clientTab,
        activeIcon: Images.clientTabActive,
        path: '/client',
    },
    {
        name: 'Schedule',
        icon: Images.scheduleTab,
        activeIcon: Images.scheduleTabActive,
        path: '/schedule',
    },

    RolePermission([PermissionList.TASK_MANAGE?.code, PermissionList.TASK_FULL_ACCESS?.code]) &&
    {
        name: 'Tasks',
        icon: Images.taskTab,
        activeIcon: Images.taskTabActive,
        path: '/tasks',
    },

    RolePermission([PermissionList.CLAIMS_READ?.code, PermissionList.CLAIM_PMT_READ?.code, PermissionList.INVOICE_READ?.code]) && {
        name: 'Billing',
        icon: Images.billingTab,
        activeIcon: Images.billingTabActive,
        path: '/billing',
        type: 'accordion',
    },

    RolePermission([PermissionList.PAYROLL_READ?.code, PermissionList.PAYROLL_MANAGE?.code]) && {
        name: 'Payroll',
        icon: Images.payrollTab,
        activeIcon: Images.payrollTabActive,
        path: '/timesheet',
        // type: 'accordion'
    },

    // RolePermission([PermissionList.FS_SERVICE_READ?.code]) &&
    // {
    //     name: "Supervision",
    //     icon: Images.staffTab,
    //     activeIcon: Images.staffTabActive,
    //     path: "/supervision",
    // },

    RolePermission([PermissionList.REPORT_MANAGE?.code]) && {
        name: 'Reporting',
        icon: Images.reportTab,
        activeIcon: Images.reportTabActive,
        path: '/report',
        type: 'accordion',
    },

    RolePermission([PermissionList.MANAGE_CUSTOM_FORM.code]) && {
        name: 'Templates',
        icon: Images.formTab,
        activeIcon: Images.formTabActive,
        path: '/templates',
    },

    RolePermission([
        PermissionList.COMPANY_PROFILE_MANAGE.code,
        PermissionList.ROLES_READ.code,
        PermissionList.SYSTEM_SERVICE_TYPES?.code,
        PermissionList.SYSTEM_CREDENTIALS?.code,
        PermissionList.SYSTEM_DEPARTMENTS?.code,
        PermissionList.SYSTEM_JOB_TITLES?.code,
        PermissionList.SYSTEM_PAYCODE_TYPES?.code,
        PermissionList.SYSTEM_MILEAGE?.code,
        PermissionList.SYSTEM_OVERTIME?.code,
        PermissionList.SYSTEM_PLACE_OF_SERVICE?.code,
        PermissionList.MANAGE_INTEGRATIONS?.code,
        PermissionList.DOMAIN_CREATE?.code,
        PermissionList.DOMAIN_READ?.code,
    ]) && {
        name: 'Settings',
        icon: Images.systemTab,
        activeIcon: Images.systemTabActive,
        path: '/settings',
        type: 'accordion',
    },

    RolePermission([PermissionList.GOAL_READ.code]) &&
        cSession && {
            name: 'Library',
            icon: Images.libraryTab,
            activeIcon: Images.libraryTabActive,
            path: '/library',
        },

    {
        name: 'Resource Center',
        icon: Images.resourceTab,
        activeIcon: Images.resourceTabActive,
        path: '/resource',
    },
];
